import localApi from '../../services/localApi'

export type PlanCode = 'BASIC' | 'ESSENTIAL' | 'PROFESSIONAL' | 'ENTERPRISE'
export type PlanFeatureKey = 'quality_reports' | 'quality_dashboard' | 'custom_label_templates' |
'project_sharing' | 'client_portfolio' | 'traceability' | 'sac' | 'account_governance'

export interface PlanLimits {
  clients: number | null
  labelsPerClient: number | null
  technicalSheetsPerClient: number | null
  activeChecklists: number | null
  qualityReportsPerMonth: number | null
  noraQueriesPerMonth: number | null
  publishedLots: number | null
}

export interface PlanCatalogItem {
  code: PlanCode
  name: string
  annualMonthly: number | null
  includedUsers: number | null
  selfService: boolean
  features: PlanFeatureKey[]
  limits: PlanLimits
}

export interface PlanCatalog {
  plans: PlanCatalogItem[]
  billingPeriods: Array<{ code: 'monthly' | 'annual', months: number, monthlyMultiplier: number }>
}

export interface AccountEntitlements {
  accountId: string
  planCode: PlanCode | null
  source: 'subscription' | 'legacy'
  features: PlanFeatureKey[]
  limits: PlanLimits | null
  includedUsers: number | null
}

export interface AccountAccess {
  accountId: string
  status: 'active' | 'expired' | 'pending' | 'legacy'
  validUntil: string | null
  canAccessApp: boolean
  canManageSubscription: boolean
}

export interface CheckoutContext {
  userId: string
  email: string
  name: string
  image: string | null
  accountName: string
  planCode: PlanCode | null
  planName: string | null
  hasSubscription: boolean
  canUpgrade: boolean
  billingPeriod: 'monthly' | 'annual' | null
  access: AccountAccess
}

interface ApiResponse<T> { success: boolean, data: T }

export const planCatalogApi = {
  async getCatalog (): Promise<PlanCatalog> {
    const response = await localApi.get<ApiResponse<PlanCatalog>>('/v1/payments/plans')
    return response.data.data
  },
  async getMyEntitlements (): Promise<AccountEntitlements> {
    const response = await localApi.get<ApiResponse<AccountEntitlements>>('/v1/accounts/me/entitlements')
    return response.data.data
  },
  async getMyAccess (): Promise<AccountAccess> {
    const response = await localApi.get<ApiResponse<AccountAccess>>('/v1/accounts/me/access')
    return response.data.data
  },
  async getCheckoutContext (): Promise<CheckoutContext> {
    const response = await localApi.get<ApiResponse<CheckoutContext>>('/v1/accounts/me/checkout')
    return response.data.data
  }
}
